import { memo } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';
import useAuth from 'hooks/useAuth';
// config
import { HEADER } from '../../../config';
// components
import { NavSectionHorizontal } from '../../../components/nav-section';
//
import navConfig from './NavConfig';
import { isModuleAllowed } from '../../../admin/accessControl';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  transition: theme.transitions.create('top', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  width: '100%',
  position: 'fixed',
  zIndex: theme.zIndex.appBar,
  padding: theme.spacing(1, 0),
  boxShadow: theme.customShadows.z8,
  top: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

function NavbarHorizontal() {
  const { permissionMap, currentAdmin } = useAuth();
  const filteredNavConfig = navConfig
    .map((group) => ({
      ...group,
      items: group.items.filter((item) =>
        isModuleAllowed(permissionMap, item.requiredModule, Boolean(currentAdmin?.is_super_admin))
      ),
    }))
    .filter((group) => group.items.length > 0);

  return (
    <RootStyle>
      <Container maxWidth={false}>
        <NavSectionHorizontal navConfig={filteredNavConfig} />
      </Container>
    </RootStyle>
  );
}

export default memo(NavbarHorizontal);
